import React, { FC } from "react";

import { Checkbox, FormFieldContainer, FormFieldLabel } from "../../forms";
import { EventsLabels, EventType } from "../types";

export type AllowedEventType = EventType.IN_PERSON | EventType.DIGITAL;

export interface EventTypeFilterProps {
  labels: EventsLabels;
  value: Record<AllowedEventType, boolean>;
  onChange: (newValue: Record<AllowedEventType, boolean>) => void;
  className?: string;
}

export const EventTypeFilter: FC<EventTypeFilterProps> = ({
  value,
  onChange,
  labels,
  className,
}) => {
  const handleChange = (eventType: AllowedEventType) => {
    onChange({ ...value, [eventType]: !value[eventType] });
  };

  return (
    <FormFieldContainer className={className}>
      <FormFieldLabel label={labels["event-type"]} />
      <div className="flex gap-5 mt-3">
        <Checkbox
          checked={value[EventType.IN_PERSON]}
          onChange={() => handleChange(EventType.IN_PERSON)}
          collapseMessage
        >
          {labels["event-type-in-presence"]}
        </Checkbox>
        <Checkbox
          checked={value[EventType.DIGITAL]}
          onChange={() => handleChange(EventType.DIGITAL)}
          collapseMessage
        >
          {labels["event-type-online"]}
        </Checkbox>
      </div>
    </FormFieldContainer>
  );
};
